import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router";
import LoginService from "../../../api/services/login_Service";
import { apiList } from "../../../api/apiList";
import { setLoginData, selectLoginData, setRememberMe } from './login.actions';
import { decrypt } from "../../../helpers/encrypt";

import TextInputFloat from "../../common/components/textInput/TextInputFloat";
import Logo from "../../common/components/Logo";
import Modal from "../../common/components/modal";
// import DarkThemeToggleComponent from "../../../darkThemeToggle";

import "react-toastify/dist/ReactToastify.css";

const Login = ({ setIsLoading, showToastMessage }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { rememberMe, credential } = useSelector(selectLoginData);

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalTitle, setModalTitle] = useState('');
  const [modalContent, setModalContent] = useState('');

  const handleLogin = async (e) => {
    e.preventDefault();
    if (username && password) {
      try {
        setIsLoading(true);
        const data = await LoginService.login({
          Username: username,
          Password: password,
          ismobile: true,
          appVersion: apiList.appVersion,
        }).json();
        setIsLoading(false);

        if (data.message === "Your account is locked!") {
          openModal('Money Ball', 'Your account is locked!');
          navigate("/login");
        } else {
          dispatch(setLoginData({ ...data, rememberMe, username, password }));
          navigate("/rules?loggedIn=true");
        }
      } catch (error) {
        setIsLoading(false);
        openModal('Money Ball', 'Login Failed!');
      }
    }
  };

  const openModal = (title, content) => {
    setModalTitle(title);
    setModalContent(content);
    setIsModalOpen(true);
  };

  const closeModal = () => setIsModalOpen(false);

  const handleRememberMeChange = () => {
    dispatch(setRememberMe());
  };

  useEffect(() => {
    if (rememberMe && credential) {
      const decrypted = decrypt(credential);
      setUsername(decrypted?.username || '');
      setPassword(decrypted?.password || '');
    }
  }, [credential, rememberMe]);

  return (
      <div
        className="flex flex-col items-center justify-center w-full min-h-screen px-4"
        style={{
          backgroundImage: `url(${require('../../../assets/images/login.jpg')})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
        }}
      >
      {/* Dark mode toggle */}
      {/* <div className="absolute top-3 right-3 z-50">
        <DarkThemeToggleComponent />
      </div> */}

      {/* <Logo /> */}

      <div className="w-full max-w-sm mt-32 text-white bg-slate-900 bg-opacity-10 border border-white/20 rounded-xl p-6 shadow-lg backdrop-blur-sm">
        <form onSubmit={handleLogin} className="flex flex-col space-y-5">
          {/* Username */}
          <div className="w-full">
            <label htmlFor="username" className="text-sm font-medium">
              Username
            </label>
            <TextInputFloat
              id="username"
              placeholder="Enter your username"
              value={username}
              type="text"
              setValue={setUsername}
            />
          </div>

          {/* Password */}
          <div className="w-full">
            <label htmlFor="password" className="text-sm font-medium">
              Password
            </label>
            <TextInputFloat
              id="password"
              placeholder="Enter your password"
              value={password}
              type="password"
              setValue={setPassword}
            />
          </div>

          {/* Remember Me */}
          <div className="flex items-center">
            <input
              id="remember-me"
              type="checkbox"
              checked={rememberMe}
              onChange={handleRememberMeChange}
              className="w-4 h-4 text-primary bg-white border-gray-300 rounded focus:ring-0"
            />
            <label htmlFor="remember-me" className="ml-2 text-sm">
              Remember Me
            </label>
          </div>

          {/* Submit */}
          <button
            type="submit"
            className="w-full py-2 px-4 mt-2 text-white font-semibold rounded-md bg-gradient-to-r from-gradient_start to-gradient_end hover:opacity-90 transition-all"
          >
            Login
          </button>
        </form>
      </div>

      {/* Modal */}
      {isModalOpen && (
        <Modal title={modalTitle} content={modalContent} onClose={closeModal} />
      )}
    </div>
  );
};

export default Login;
